<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader
        :title="$t('message.companyProfile.monitoredKeywords.title')"
      />
      <v-col cols="12">
        <v-card
          class="container"
          :class="{ 'container--center': !failitiesAdded }"
        >
          <template v-if="loading">
            <SectionLoader :status="loading" />
          </template>
          <template v-else>
            <MonitoredKeywords v-if="failitiesAdded" />
            <div v-else>
              <v-row justify="center" align-content="center" class="no-data">
                <v-col sm="6" class="text-center">
                  <h3 class="mb-3">
                    {{ $t("message.common.addMonitoredKeywords") }}
                  </h3>
                  <p>
                    {{ $t("message.visibility.summary.noKeywordsInfo") }}
                  </p>
                  <div class="d-flex flex-column mt-8">
                    <ui-button
                      color="primary"
                      icon="icon-google"
                      class="mb-2 mx-auto"
                      style="max-width: 250px; width: 100%;"
                      :to="{ name: 'profile-gmb-accounts' }"
                    >
                      {{ $t("message.common.importFacilities") }}
                    </ui-button>
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ViewHeader from "@/components/ui/ViewHeader";
import MonitoredKeywords from "@/components/Keywords/MonitoredKeywords";
import SectionLoader from "@/components/Loader/SectionLoader";

import { mapState } from "vuex";

export default {
  name: "ProfileCompanyInWeb",
  components: {
    ViewHeader,
    MonitoredKeywords,
    SectionLoader
  },
  data() {
    return {
      failitiesAdded: false
    };
  },

  computed: {
    ...mapState({
      loading: state => state.company.loading
    })
  },
  async created() {
    await this.$store.commit("company/SET_LOADING", true);
    this.failitiesAdded =
      this.$store.state.company.company.facilities_count > 0;
    await this.$store.commit("company/SET_LOADING", false);
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 650px;
  padding: $spacing * 3 $spacing * 2;
  &--center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
